import React from 'react';
import { Form, Icon, Message, Button, Modal, Header, Divider } from 'semantic-ui-react'
import _ from 'lodash';

const Impuestos = ({elemento}) => {
  return(
    <option value={elemento._id}>{elemento.descrImpto} ={">"} {elemento.porcImpto} %</option>
)
};

const ListaImpto = ({styles, list, handleChange, argsAddImpto}) => {
    const Nivel1Detalle = list.map((elemento, _id) => <Impuestos elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="idImpto" id="miLista1" value={argsAddImpto.idImpto} onChange={(ev)=>handleChange(ev, list)}>
                <option style={styles.input} value="">Seleccionar...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};

const Servicios = ({elemento}) => {
    return(
        <option value={elemento.codigoServicio}>{elemento.nombreResumido} ={">"} {elemento.descripcionServicio}</option>
    )
  };

  const ListaServ = ({styles, list, handleChange, argsAddImpto}) => {
      const Nivel1Detalle = list.map((elemento, i) => <Servicios elemento={elemento} key={i} />);
      return(
          <div>
              <select style={styles.input} className="ui simple selection dropdown fluid" name="codigoServicio" id="miLista" value={argsAddImpto.codigoServicio} onChange={(ev)=>handleChange(ev, list)}>
                  <option style={styles.input} value="">Seleccionar...</option>
                  {Nivel1Detalle}
              </select>
          </div>
      )
  };
  
//

const ServiciosTar = ({elemento, handleChange}) => {
  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoServTar' id={elemento._id} checked={elemento.estadoServ} onChange={(ev)=>handleChange(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.descrImpto}</td>
      <td className=''>{elemento.porcImpto}</td>
    </tr>
  )
};

const ListaServTar = ({list, handleChange}) => {
  const nivel1Detalle = list.map((elemento, _id) => <ServiciosTar elemento={elemento} handleChange={handleChange} key={_id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//

class ConfSerTI2 extends React.Component {
  state={
      listServTar: this.props.lisServTar,
      errors: this.props.errors,
      open: false,
      servicios: _(this.props.lisServTar)
      .groupBy('codigoServicio', 'descrClaseServ', 'descripcionServicio', 'nombreResumido')
      .map((obj, key) => ({
        'codigoServicio': key,
        'descrClaseServ': obj[0].descrClaseServ,
        'descripcionServicio': obj[0].descripcionServicio,
        'nombreResumido': obj[0].nombreResumido,
      }))
      .value(),
      argsAddImpto: {
        codigoServicio: 'Seleccionar...',
        idImpto: 'Seleccionar...'
      }
  }

  // ordenarArrayAsc = (array, campo) => {
  //   array.sort(function (a, b) {
  //      return a[campo] > b[campo];
  //   });
  // }

  handleRefresh = () => {
    let arrayServTar=this.state.listServTar
    
    const arrayServ1 = arrayServTar.filter(item => item.estadoServ===false);
    arrayServ1.forEach((elemento1, _id) => {
      arrayServTar.forEach((elemento, _id) => {
        if(elemento.estadoServ===false && elemento1._id===elemento._id){
          const indexServ = arrayServTar.findIndex( servicio => servicio._id === elemento._id );
          arrayServTar.splice(indexServ, 1);
        }
      })
    })

    // this.ordenarArrayAsc(arrayServTar, 'descrClaseServ')
    arrayServTar = _.orderBy(arrayServTar, ['descrClaseServ', 'descripcionServicio'])

    this.setState({listServTar: arrayServTar})
    this.setState({open: false})
    this.setState({errors: []})

    this.setState({servicios: _(arrayServTar)
    .groupBy('codigoServicio', 'descrClaseServ', 'descripcionServicio', 'nombreResumido')
    .map((obj, key) => ({
      'codigoServicio': key,
      'descrClaseServ': obj[0].descrClaseServ,
      'descripcionServicio': obj[0].descripcionServicio,
      'nombreResumido': obj[0].nombreResumido,
    }))
    .value()})
  }

  handleAddImpto = () => {
    let arrayServTar=this.state.listServTar
    let argsAddImpto=this.state.argsAddImpto

    const errors = [];
    if(argsAddImpto.codigoServicio==="Seleccionar..." || argsAddImpto.codigoServicio===""){
      errors.push({path: 'Servicio', message: "Debe seleccionar el servicio"});
    }
    if(argsAddImpto.idImpto==="Seleccionar..." || argsAddImpto.idImpto===""){
      errors.push({path: 'Impuesto', message: "Debe seleccionar el impuesto"});
    }

    let arrayServ1 = arrayServTar.filter(item => item.codigoServicio===argsAddImpto.codigoServicio);
    let idServImpto=-2
    let indexServ
    arrayServ1.forEach((elemento, _id) => {
      if(elemento.idImpto===null){
        indexServ = arrayServTar.findIndex( servicio => servicio.codigoServicio == elemento.codigoServicio );
        idServImpto=elemento._id
      }
      if(elemento.idImpto===argsAddImpto.idImpto){
        idServImpto=-1
      }
    })
    if(idServImpto===-1){
      errors.push({path: 'Impuesto', message: "El impuesto ya esta asignado al servicio"});
    }
    this.setState({errors})
    if(errors.length===0){
      const idNuevo = +arrayServTar.length
      if(idServImpto===-2){
//nuevo
        arrayServTar.push({_id: idNuevo, codigoServicio: argsAddImpto.codigoServicio, descrClaseServ: argsAddImpto.descrClaseServ, nombreResumido: argsAddImpto.nombreResumido, descripcionServicio: argsAddImpto.descripcionServicio,
          idImpto: argsAddImpto.idImpto, codigoImpto: argsAddImpto.codigoImpto,
          descrImpto: argsAddImpto.descrImpto, porcImpto: argsAddImpto.porcImpto,
          estadoServ: true});
      }else{
//nulo
        arrayServTar[indexServ] = ({_id: idServImpto, codigoServicio: argsAddImpto.codigoServicio, descrClaseServ: argsAddImpto.descrClaseServ, nombreResumido: argsAddImpto.nombreResumido, descripcionServicio: argsAddImpto.descripcionServicio,
          idImpto: argsAddImpto.idImpto, codigoImpto: argsAddImpto.codigoImpto,
          descrImpto: argsAddImpto.descrImpto, porcImpto: argsAddImpto.porcImpto,
          estadoServ: true});
      }
    }

    this.setState({argsAddImpto: {
      codigoServicio: 'Seleccionar...',
      idImpto: 'Seleccionar...'
    }})

    // this.ordenarArrayAsc(arrayServTar, 'descrClaseServ')
    arrayServTar = _.orderBy(arrayServTar, ['descrClaseServ', 'descripcionServicio'])
    this.setState({listServTar: arrayServTar})
  }

  handleChange = (ev, elemento) => {
    if(ev.target.name === "estadoServTar"){
      let listServTar=this.state.listServTar
      const indexServ = listServTar.findIndex( servicio => servicio._id == ev.target.id );

      if(elemento.estadoServ===false){
          listServTar[indexServ].estadoServ = true
      }else{
          listServTar[indexServ].estadoServ = false
      }
      this.setState({listServTar});
    }
    if(ev.target.name === "codigoServicio"){
      const indexServ = elemento.findIndex( servicio => servicio.codigoServicio == ev.target.value );

      const argsAddImpto = this.state.argsAddImpto
      argsAddImpto[ev.target.name] = ev.target.value
      if(ev.target.value!==''){
        argsAddImpto['descrClaseServ'] = elemento[indexServ].descrClaseServ
        argsAddImpto['nombreResumido'] = elemento[indexServ].nombreResumido
        argsAddImpto['descripcionServicio'] = elemento[indexServ].descripcionServicio
      }
      this.setState({argsAddImpto});
    }
    if(ev.target.name === "idImpto"){
      const indexServ = elemento.findIndex( impto => impto._id == ev.target.value );

      const argsAddImpto = this.state.argsAddImpto
      argsAddImpto[ev.target.name] = ev.target.value
      if(ev.target.value!==''){
        argsAddImpto['codigoImpto'] = elemento[indexServ].codigoImpto
        argsAddImpto['descrImpto'] = elemento[indexServ].descrImpto
        argsAddImpto['porcImpto'] = elemento[indexServ].porcImpto
      }
      this.setState({argsAddImpto});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel"){this.setState({open: true})};

    if(btnPress==="No"){
        this.setState({open: false})
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps){
    if(this.props.lisServTar!==nextProps.lisServTar){
        this.setState({listServTar: this.props.lisServTarIni})
    }

    if(this.props.errors!==nextProps.errors){
      this.setState({errors: nextProps.errors})
    }
    this.setState({open: false})

    this.setState({servicios: _(this.props.lisServTarIni)
      .groupBy('codigoServicio', 'descrClaseServ', 'descripcionServicio', 'nombreResumido')
      .map((obj, key) => ({
        'codigoServicio': key,
        'descrClaseServ': obj[0].descrClaseServ,
        'descripcionServicio': obj[0].descripcionServicio,
        'nombreResumido': obj[0].nombreResumido,
      }))
      .value()})
  }
  
  render(){
    const {listServTar, errors, open, servicios, argsAddImpto} = this.state;
    const a2510150101 = this.props.autorizacUA.findIndex( autorizac => autorizac === "2510150101" );

    // console.log(this.state)
    // console.log(this.props)
    // console.log(listServTar)
    return(
      <div>
        <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={
          <div>
            <Button className='ui right labeled icon button' style={this.props.styles.titBuscar}>
                <i className='large hand point down yellow icon'></i>
                Tarifa: {this.props.tarifa}
            </Button>
            <Button name="btnRefr" id="btnRefr"  className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.handleRefresh}>
                <i className='large redo yellow icon'></i>
                Refrescar
            </Button>
            <Button name="btnVrInic" id="btnVrInic" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.props.handleVrinic}>
                <i className='large refresh yellow icon'></i>
                Valores iniciales
            </Button>
            {a2510150101!==-1 &&
            <Button name="btnUpdDel" id="btnUpdDel" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                <i className='large save yellow icon'></i>
                Guardar
            </Button>
            }
          </div>
        }>

          <Header icon='edit' color='red' content='Modificar tarifa' />
      
          <Modal.Content>
              <p>Esta usted seguro ?</p>
          </Modal.Content>
          <Modal.Actions>
              <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                  <Icon dato1="No" name='remove' /> No
              </Button>
              <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.props.handleSubmit(ev, listServTar)}>
                  <Icon dato1="Si" name='checkmark' /> Si
              </Button>
          </Modal.Actions>
        </Modal>

        {
            errors.length?<Message negative header="Los siguientes errores:"
            list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
        }

      <div style={this.props.styles.box}>
        <div className='ui blue inverted raised segment'>
          <a className='ui large label' style={this.props.styles.styTableSup}>Impuestos asignados a los servicios de la tarifa</a>
          <table className='ui olive inverted celled selectable table' style={this.props.styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className=''></th>
                <th className=''>Clase</th>
                <th className=''>Servicio</th>
                <th className=''>Descripción servicio</th>
                <th className=''>Descripción impuesto</th>
                <th className=''>%</th>
              </tr>
            </thead>
            <ListaServTar list={listServTar} handleChange={this.handleChange}/>
          </table>          
        </div>

        <div className='ui blue inverted raised segment'>
          <a className='ui large label' style={this.props.styles.styTableInf}>Asignar impuestos a los servicios de la tarifa</a>
          <div>
            <Form onSubmit={(ev)=>this.props.handleSubmit(ev, listServTar)}>
              <Form.Field>
                  <label style={this.props.styles.label}>Servicio</label>
                  <ListaServ styles={this.props.styles} list={servicios} handleChange={this.handleChange} argsAddImpto={argsAddImpto}/>
              </Form.Field>
              <Form.Field>
                  <label style={this.props.styles.label}>Impuesto</label>
                  <ListaImpto styles={this.props.styles} list={this.props.list} handleChange={this.handleChange} argsAddImpto={argsAddImpto}/>
              </Form.Field>
            </Form>

            <Divider inverted />

            <Button style={this.props.styles.confirmar} name="btnUpdDel" id="btnUpdDel" className="ui right labeled green icon" fluid  onClick={this.handleAddImpto}>
                <i className="large plus yellow icon"></i>
                Agregar
            </Button>
          </div>
        </div>
      </div>
      </div>
    )
  }
}

export default ConfSerTI2